import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { NotificationContainer } from 'react-notifications';

import './global-styles.scss';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Home from '../Home';
import Post from '../Post';
import Category from '../Category';
import Tag from '../Tag';
import PageNotFound from '../PageNotFound';

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isScrolling: false
    };

    this._timeout = null;
    this.fixHeader = this.fixHeader.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.fixHeader);
  }

  fixHeader(e) {
    //supported by all browsers, including IE9+
    let scrollTop = window.pageYOffset; //https://www.w3schools.com/jsref/prop_win_pagexoffset.asp

    //if there is already a timeout in process cancel it
    if (this._timeout) {
      clearTimeout(this._timeout);
    }

    this._timeout = setTimeout(() => {
      this._timeout = null;
      if (scrollTop < 100) {
        this.setState({ isScrolling: false });
      }
    }, 100);

    if (scrollTop >= 100) {
      this.setState({ isScrolling: true });
    }
  }

  render() {
    return (
      <div className="app-container" ref="app-container">
        <Header isScrolling={this.state.isScrolling} />

        <Switch>
          <Route exact path='/' component={Home} />

          <Route path='/posts/:post' component={Post} />

          <Route path='/category/:category' component={Category} />

          <Route path='/tag/:tag' component={Tag} />

          <Route component={PageNotFound} />
        </Switch>
        <Footer />
        <NotificationContainer ref="notification-container" />
        <div className="global-popup-overlay"></div>
      </div>
    );
  }
}

export default withRouter(App);
